import React from "react";
import VoucherTable from "../../components/tables/agro-dealer/VoucherTable";
import WithAuth from "../../hoc/WithAuth";

const VoucherPage = () => {
  return (
    <div className="bg-transparent md:bg-white md:rounded-2 md:px-[50px] md:py-5 md:mt-[25px] md:pb-[22px] rounded-xl">
      <VoucherTable />
    </div>
  );
};

export default WithAuth(VoucherPage);
